/**
 * View Transitions helper: run a state update inside document.startViewTransition when the
 * browser supports it (Chromium), so keyed elements (view-transition-name) morph between
 * states instead of hard-cutting. Falls back to a plain update everywhere else, and always
 * respects prefers-reduced-motion. Never throws, navigation must not break on a polish layer.
 */
export function vt(update: () => void): void {
  try {
    const doc = document as Document & { startViewTransition?: (cb: () => void) => unknown };
    const reduceMotion =
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (typeof doc.startViewTransition === "function" && !reduceMotion) {
      doc.startViewTransition(update);
      return;
    }
  } catch {
    /* fall through to the plain update */
  }
  try {
    update();
  } catch {
    /* never throw from the transition wrapper */
  }
}
